import { useMemo } from 'react';
import useDebugEventTracking from './useDebugEventTracking';
import useMediaEventTracking from './useMediaEventTracking';
import useWidgetEventTracking from './useWidgetEventTracking';

export default function useTracking() {
  const widgetTracking = useWidgetEventTracking();
  const mediaTracking = useMediaEventTracking();
  const debugTracking = useDebugEventTracking();

  return useMemo(
    () => ({
      ...widgetTracking,
      ...mediaTracking,
      ...debugTracking,
    }),
    [debugTracking, mediaTracking, widgetTracking],
  );
}
